// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const attributeSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  color: z.string().max(20),
  entityType: z.string().max(50),
  type: z.string().max(200),
  sortOrder: z.number().int().min(0).max(999999).optional(),
  popularity: z.number().min(0).max(999999).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type AttributeInput = z.infer<typeof attributeSchema>
